/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TDeleteOfferFromFavoritesModel = IModel<
  IDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesResponse
>;

export interface IDeleteOfferFromFavoritesRequest {
  /** Тип сделки **/
  dealType: EDealType;
  /** realty Id объекта(объявка/ЖК) **/
  entityId: number;
  /** тип объекта(объявка/ЖК) **/
  entityType: EEntityType;
  /** Флаг принудительного удаления из папок **/
  forceRemoveFromFolders?: boolean | null;
}

export type TDeleteOfferFromFavoritesResponse =
  | IDeleteOfferFromFavoritesResponse200
  | IDeleteOfferFromFavoritesResponse400;

export interface IDeleteOfferFromFavoritesResponse200 extends IModelResponse<IDeleteOfferFromFavoritesResponse> {
  statusCode: 200;
}

export interface IDeleteOfferFromFavoritesResponse400 extends IModelResponse<IDeleteOfferFromFavoritesResponseError> {
  statusCode: 400;
}

export interface IDeleteOfferFromFavoritesResponse {
  /** Статус выполненного действия **/
  status?: string | null;
}

export interface IDeleteOfferFromFavoritesResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IDeleteOfferFromFavoritesResponse | IDeleteOfferFromFavoritesResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Коммерческая **/
  OfferCommercial = 'offerCommercial',
  /** Жилая **/
  OfferResidental = 'offerResidental',
  /** Загородка **/
  OfferSuburban = 'offerSuburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IDeleteOfferFromFavoritesResponse): TResponse200;
  400(response: IDeleteOfferFromFavoritesResponseError): TResponse400;
}
